import { ThemeType, ThemeConfig } from './types';

const THEME_STORAGE_KEY = 'admin-theme';

export const getStoredTheme = (): ThemeType => {
  if (typeof window === 'undefined') return 'light';

  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  if (stored === 'light' || stored === 'dark') {
    return stored;
  }

  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  return prefersDark ? 'dark' : 'light';
};

export const setStoredTheme = (theme: ThemeType): void => {
  if (typeof window === 'undefined') return;
  localStorage.setItem(THEME_STORAGE_KEY, theme);
};

export const applyThemeToDOM = (themeConfig: ThemeConfig): void => {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;

  Object.entries(themeConfig).forEach(([key, value]) => {
    const cssVariable = `--theme-${key.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    root.style.setProperty(cssVariable, value);
  });
};

export const initializeSystemThemeListener = (callback: (theme: ThemeType) => void) => {
  if (typeof window === 'undefined') return () => {};

  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

  const handleChange = (e: MediaQueryListEvent) => {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    if (!stored) {
      callback(e.matches ? 'dark' : 'light');
    }
  };

  mediaQuery.addEventListener('change', handleChange);

  return () => {
    mediaQuery.removeEventListener('change', handleChange);
  };
};
